import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { SubFolderDocumentResponse } from "../../Controllers/Types/Project/ProjectResponse";
import { baseURL } from "../ApiConstant";

export const subFolderDocumentGetDataAPI = async (subFolderId: number): Promise<SubFolderDocumentResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/sub-folder-document-collection/${subFolderId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data['data'] };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


export const subFolderDocumentCreateAPI = async (sub_folder_id: number, title: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('sub_folder_id', String(sub_folder_id));
        formData.append('title', title); 
        if (path) {
            formData.append('path', path);
        }        

        const response = await fetch(`${baseURL}/api/sub-folder-document-collection/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,
        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const subFolderDocumentUpdateAPI = async (documentId: number, title: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('title', title); 
        if (path) {
            formData.append('path', path);
        }        

        const response = await fetch(`${baseURL}/api/sub-folder-document-collection/update/${documentId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const subFolderDocumentDeleteAPI = async (documentId: number): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/sub-folder-document-collection/delete/${documentId}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};